export default __webpack_public_path__ + "static/media/Honored Gloves of the Mound.6ed3a0f1.jpg";